module.exports = __webpack_public_path__ + "img/boy_3.de1987d3.svg";